module.exports = __webpack_public_path__ + "img/wxgzh.37487c39.png";